import { SellingPlanGroupApiResponse } from "@smartrr/shared/entities/SellingPlanGroup";

export function hasProductsSelected(sellingPlanGroup: SellingPlanGroupApiResponse): boolean {
  return Boolean(sellingPlanGroup.productIds.length || sellingPlanGroup.productVariantIds.length);
}
